import { takeLatest, put, call, select } from 'redux-saga/effects';
import firebase from 'firebase/app';
import localforage from 'localforage';
import axios from 'axios';
import { groupBy } from 'underscore';

import {
	GET_PLACES, SET_PLACES, GET_GENEROS,
	SET_GENEROS, GET_SERVICES, SET_SERVICES,
	SET_PACKAGE, GET_PACKAGE, SAVE_PACKAGE,
	SET_LOCALFORAGE_LOADED, SEND_ESTIMATE,
	INPUT_ESTIMATE_NAME, INPUT_ESTIMATE_EMAIL,
	INPUT_ESTIMATE_PHONE, INPUT_ESTIMATE_DATE_EVENT,
	INPUT_ESTIMATE_TYPE_EVENT,
	INPUT_ESTIMATE_MSG, SET_ESTIMATE_STATUS
} from '../actions/Types';

export function* packageSaga() {
	yield takeLatest(GET_PLACES, getPlaces);
	yield takeLatest(GET_GENEROS, getGeneros);
	yield takeLatest(GET_SERVICES, getServices);
	yield takeLatest(GET_PACKAGE, getPackage);
	yield takeLatest(SAVE_PACKAGE, savePackage);
	yield takeLatest(SEND_ESTIMATE, sendEstimate);
}

function* getPlaces() {
	try {
		const data = yield call(firebaseGet);
		yield put({ type: SET_PLACES, payload: data });
	} catch (error) {
		console.log('getPlaces res error', error);
	}
}

function* getGeneros() {
	try {
		const data = yield call(firebaseGetGeneros);
		yield put({ type: SET_GENEROS, payload: data });
	} catch (error) {
		console.log('getItems res error', error);
	}
}

function* getServices() {
	try {
		const data = yield call(firebaseGetServices);
		yield put({ type: SET_SERVICES, payload: data });
	} catch (error) {
		console.log('getServices res error', error);
	}
}

function* getPackage(){
	try {
		const state = yield select(state => state.PackageReducer);
		if(!state.localforageLoaded){
			const data = yield call(localForageGetPackage);
			yield put({ type: SET_PACKAGE, payload: data || {}});
			yield put({ type: SET_LOCALFORAGE_LOADED, payload: true });
		}
	} catch (error) {
		console.log('getPackage res error', error);
	}
}

function* savePackage() {
	try {
		const state = yield select(state => state.PackageReducer);
		localforage.setItem('package', state.package);
	} catch (error) {
		console.log('setContact error', error);
	}
}

const firebaseGetGeneros = () => {
	// console.log('firebaseGet');
	const firestore = firebase.firestore();
	return firestore.collection("database").doc('base').collection('genres').get().then(snap => {
		// console.log('genres', snap.size);
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		return arr;
	});
};

const firebaseGet = () => {
	const firestore = firebase.firestore();
	return firestore.collection("database").doc('base').collection('places').get().then(snap => {
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		// console.log('arr', arr);
		return arr;
	});
};

const firebaseGetServices = () => {
	const firestore = firebase.firestore();
	return firestore.collection("database").doc('base').collection('services').get().then(snap => {
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		return arr;
	});
};

const localForageGetPackage = () => {
	return localforage.getItem('package');
};

function* sendEstimate() {
	yield put({ type: SET_ESTIMATE_STATUS, payload: 'loading' });

	try {
		const state = yield select(state => state.EstimateReducer);
		const packageObj = yield call(localForageGetPackage);
		const stateContact = yield select(state => state.ContactReducer);
		// console.log('sendEstimate', { ...state, ...packageObj});

		const { services, place, artistas } = packageObj;
		let resume = [];
		
		if (place && place.name) {
			resume.push({ name: place.name, list: [place.spot] });
		} else {
			resume.push({ name: 'HOTELES', list: [], other: localStorage.getItem('otherPlace') });
		}

		if (artistas && artistas.length) {
			let obj = groupBy(artistas, 'category');
			for (let key in obj) {
				resume.push({ name: key, list: obj[key] });
			}
		} else {
			resume.push({ name: 'ARTISTAS', list: [], other: localStorage.getItem('otherArtist') });
		}

		if (services && services.length) {
			let obj = groupBy(services, 'category');
			for (let key in obj) {
				resume.push({ name: key, list: obj[key] });
			}
		} else {
			resume.push({ name: 'SERVICIOS', list: [], other: localStorage.getItem('otherService') });
		}

		let msg = `
			<b>Nombre:</b> ${state.name} <br />
			<b>E-Mail:</b> ${state.email} <br />
			<b>Teléfono:</b> ${state.phone} <br />
			<b>Fecha del evento:</b> ${state.dateEvent} <br />
			<b>Tipo de evento:</b> ${state.typeEvent} <br />
			<b>Mensaje:</b> ${state.msg} <br />

			<ul>
		`;

		const loop = arr => {
			if (!arr || arr.length === 0) return '';
			let s = ` <ul> `;
			arr.forEach(item => s += ` <li>${item.name}</li> `);
			s += ` </ul> `;

			return s;
		};

		resume.forEach(item => {
			msg += ` <li> <b>${item.name}</b> ${loop(item.list)}</li> `;
			msg += ` <li> ${item.other} </li> `;
		});

		msg += ` </ul> `;

		let params = {
			to: stateContact.emailDB,
			subject: 'Cotizar Montamos tu Patry',
			msg
		};

		yield call(axiosSend, params);
		yield put({ type: INPUT_ESTIMATE_NAME, payload: '' });
		yield put({ type: INPUT_ESTIMATE_EMAIL, payload: '' });
		yield put({ type: INPUT_ESTIMATE_PHONE, payload: '' });
		yield put({ type: INPUT_ESTIMATE_DATE_EVENT, payload: '' });
		yield put({ type: INPUT_ESTIMATE_TYPE_EVENT, payload: '' });
		yield put({ type: INPUT_ESTIMATE_MSG, payload: '' });
		yield put({ type: SET_ESTIMATE_STATUS, payload: 'ok' });
		yield put({ type: SET_PACKAGE, payload: {} });
		yield savePackage();
	} catch (error) {
		console.log('sendEstimate error', error);
		yield put({ type: SET_ESTIMATE_STATUS, payload: 'error' });
	}
}

const axiosSend = params => {
	return axios.post(`https://morfosweb.com/contato_senior.php`, params);
};


// WEBPACK FOOTER //
// ./src/sagas/packageSaga.js